import { Capture } from "@cleeng/mediastore-sdk";
import React from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../constants";
import axios from "axios";
import { axiosConfig } from "../../../utils";

function CapturePage() {
  const navigate = useNavigate();

  const handleNavigate = async () => {
    const offerId = localStorage.getItem("offerId");
    if (offerId) {
      try {
        const res = await axios.get(`${API_URL}/offers/${offerId}`, axiosConfig());
        const offer = (res && res.data && res.data.responseData);
        if (offer) {
          navigate(`/checkout?offerId=${offer.offerId}`);
          return;
        }
      } catch (error) {
      } finally {
        localStorage.removeItem("offerId");
      }
    }
    navigate("/choose-plan");
  };
  return <Capture onSuccess={handleNavigate} />;
}

export default CapturePage;
